// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterHeader__root--1zQRG"};